import { render, staticRenderFns } from "./ProductsValue.vue?vue&type=template&id=2b9f9d8b"
import script from "./ProductsValue.vue?vue&type=script&lang=js"
export * from "./ProductsValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports